import Nullstack from 'nullstack';
export default function IconWalletOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wallet-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 8v-3a1 1 0 0 0 -1 -1h-8m-3.413 .584a2 2 0 0 0 1.413 3.416h2m4 0h6a1 1 0 0 1 1 1v3"
  }), "   ", Nullstack.element("path", {
    d: "M19 19a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
  }), "   ", Nullstack.element("path", {
    d: "M16 12h4v4m-4 0a2 2 0 0 1 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}